/**
 * @type Action Types
 */
export var AIF_PMS = "AIF_PMS";
export var AIF_PMS_UPDATE = "AIF_PMS_UPDATE";
export var AIF_PMS_APPLY_SORT = "AIF_PMS_APPLY_SORT";
export var AIF_PMS_UPDATE_SORTED_DATA = "AIF_PMS_UPDATE_SORTED_DATA";
export var AIF_PMS_UPDATE_SEARCH_DATA = "AIF_PMS_UPDATE_SEARCH_DATA";
export var AIF_PMS_UPDATE_MSG = "AIF_PMS_UPDATE_MSG";
export var AIF_PMS_CLEAR_MSG = "AIF_PMS_CLEAR_MSG";
export var AIF_PMS_CLEAR_SORT = "AIF_PMS_CLEAR_SORT";
export var AIF_PMS_ERROR = "AIF_PMS_ERROR";
export var AIF_PMS_HIDE_ERROR = "AIF_PMS_HIDE_ERROR";
export var AIF_PMS_START_LOADER = "AIF_PMS_START_LOADER";
export var AIF_PMS_STOP_LOADER = "AIF_PMS_STOP_LOADER";
export var AIF_PMS_TABLE_START_LOADER = "AIF_PMS_TABLE_START_LOADER";
export var AIF_PMS_TABLE_STOP_LOADER = "AIF_PMS_TABLE_STOP_LOADER";
export var AIF_PMS_PARAMS = "AIF_PMS_PARAMS";
export var AIF_PMS_CLEAR_SEARCH_DATA = "AIF_PMS_CLEAR_SEARCH_DATA";
export var IF_PMS_VALIDATE_FORM_NUMBER = "IF_PMS_VALIDATE_FORM_NUMBER";
export var AIF_PMS_RECENT_CLIENT_SEARCH_DATA = "AIF_PMS_RECENT_CLIENT_SEARCH_DATA";
export var AIF_PMS_PRODUCT_DETAILS_DATA = "AIF_PMS_PRODUCT_DETAILS_DATA";
export var AIF_PMS_FILTER_DETAILS_DATA_AMC = "AIF_PMS_FILTER_DETAILS_DATA_AMC";
export var AIF_PMS_FILTER_DETAILS_DATA_CATEGORY = "AIF_PMS_FILTER_DETAILS_DATA_CATEGORY";
export var AIF_PMS_FILTER_DETAILS_DATA_FUND = "AIF_PMS_FILTER_DETAILS_DATA_FUND";
export var AIF_PMS_FILTER_DETAILS_FUND_NAME = "AIF_PMS_FILTER_DETAILS_FUND_NAME";
export var RESET_PAYMENT_PROCESS_STATE = "RESET_PAYMENT_PROCESS_STATE";
export var UPDATE_DRAFT_ORDER_COUNT = "UPDATE_DRAFT_ORDER_COUNT";
export var UPDATE_PREVIEW_DOCS = "UPDATE_PREVIEW_DOCS";
export var UPDATE_DELTED_DRAFT_DOCS = "UPDATE_DELETED_DRAFT_DOCS";
export var UPDATE_SAVE_DRAFT_DOCS = "UPDATE_SAVE_DRAFT_DOCS";
export var UPDATE_DRAFT_ORDER_DECLARATIONS = "UPDATE_DRAFT_ORDER_DECLARATIONS";
export var UPDATE_SAVE_DRAFT_ORDERS = "UPDATE_SAVE_DRAFT_ORDERS";
export var UPDATE_WATCHLIST_DATA = "UPDATE_WATCHLIST_DATA";
export var UPDATE_GET_DRAFT_ORDERS = "UPDATE_GET_DRAFT_ORDERS";
export var UPDATE_DRAFT_ORDERS_DETAILS = "UPDATE_DRAFT_ORDERS_DETAILS";
export var UPDATE_BOOKMARK = "UPDATE_BOOKMARK";
export var UPDATE_BOOKMARK_WATCHLIST = "UPDATE_BOOKMARK_WATCHLIST";
export var UPDATE_SUB_CATEGORY_ID = "UPDATE_SUB_CATEGORY_ID";
export var UPDATE_SUB_CATEGORY_PMS_ID = "UPDATE_SUB_CATEGORY_PMS_ID";
export var UPDATE_CLIENT_DETAILS = "UPDATE_CLIENT_DETAILS";
export var UPDATE_TRANS_ID = "UPDATE_TRANS_ID";
export var CLICKED_FROM_DRAFT = "CLICKED_FROM_DRAFT";
export var DRAFT_LOADER = "DRAFT_LOADER";
export var AIF_PMS_PRODUCT_DOWNLOAD_DATA = "AIF_PMS_PRODUCT_DOWNLOAD_DATA";
export var UPDATE_MULTI_BOOKMARK = "UPDATE_MULTI_BOOKMARK";
export var AIF_PMS_ORDER_DATA = "AIF_PMS_ORDER_DATA";
export var AIF_PMS_FILTER_LIST_DATA_FUND_NAME = "AIF_PMS_FILTER_LIST_DATA_FUND_NAME";
export var AIF_PMS_FILTER_LIST_DATA_Benchmark = "AIF_PMS_FILTER_LIST_DATA_Benchmark";
export var AIF_PMS_FILTER_LIST_DATA_Tenure = "AIF_PMS_FILTER_LIST_DATA_Tenure";
export var AIF_PMS_FILTER_LIST_DATA_AIF_FUND_NAME = "AIF_PMS_FILTER_LIST_DATA_AIF_FUND_NAME";
export var UPDATE_COMMON_BANK_MASTER = "UPDATE_COMMON_BANK_MASTER";
